module.exports = __webpack_public_path__ + "img/timeline_mainevent-13.e25a5381.jpg";